import { gql } from 'urql'

import { ORGANIZATION, SHALLOW_ORGANIZATION } from '@app/queries/fragments'

export const GET_ORGANIZATIONS = gql`
  ${ORGANIZATION}
  ${SHALLOW_ORGANIZATION}
  query GetOrganizations(
    $isNotShallow: Boolean = false
    $isShallow: Boolean = false
    $searchTerm: String!
    $where: organization_bool_exp
  ) {
    orgs: search_organizations(
      args: { search_term: $searchTerm }
      where: $where
      limit: 50
    ) {
      ...Organization @include(if: $isNotShallow)
      ...ShallowOrganization @include(if: $isShallow)
      members @include(if: $isNotShallow) {
        profile {
          lastActivity
        }
      }
    }
  }
`
